import styled from 'styled-components';

export const Container = styled.div`
	flex: 1;
	width: 100%;
	height: 100%;
`;

export const Content = styled.div`
	flex: 1;
  display: flex;
	// width: 100%;
	// height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 3.42rem;
  // margin-left: 4.4rem;
  // padding: 1rem 1.5rem 5rem;
	padding: 4.42rem 1.5rem 5rem 5.5rem;
	
	// 767px
  @media (max-width: 47.9375rem) {
    margin-top: 6rem; // margin-top: 3.9rem;
    margin-left: 0;
		padding: 1rem 0.5rem 5rem;
  }
`;

export const ClassifTitle = styled.div`
	display: flex;
	width: 100%;
	align-Items: flex-start;
	margin-Top: 3.42rem;

	span {
		font-size: 1.125rem; // 1.125rem = 18px
		color: var(--azul-razio);
		border-bottom-width: 0.125rem; // 0.125rem = 2px
		border-bottom-color: var(--azul-razio);
	}
`;